import {type Omit} from '@wandb/weave/common/types/base';

import type * as UtilReport from '../../../util/report';
import {type Ref as DiscussionThreadRef} from '../discussionThread/types';
import type * as MarkdownBlockTypes from '../markdownBlock/types';
import type * as PanelSettingsTypes from '../panelSettings/types';
import type * as SectionTypes from '../section/types';
import type * as ViewTypes from '../types';

export const REPORT_VIEW_TYPE = 'runs';

export type ReportConfig = UtilReport.SlateReport;

export type ReportWidthOption = 'readable' | 'fixed' | 'fluid' | 'profile';

export type ReportPageNormalized = Omit<
  ReportConfig,
  'panelSettings' | 'discussionThreads'
> & {
  panelSettingsRef: ViewTypes.PartRefFromObjSchema<PanelSettingsTypes.PanelSettingsObjSchema>;
  discussionThreadRefs: DiscussionThreadRef[];
};

export type Ref = ViewTypes.PartRefFromObjSchema<ReportObjSchema>;

export type ViewRef = ViewTypes.ViewRefFromObjSchema<ReportObjSchema>;

export interface ReportObjSchema {
  type: 'runs'; // legacy name
  whole: ReportConfig;
  part: ReportPageNormalized;
}

export type BlockRef = MarkdownBlockTypes.Ref | SectionTypes.Ref;
export type BlockConfig = MarkdownBlockTypes.Config | SectionTypes.Config;
